import billingModule from '../../billing.module';

class BillingPaymentService {
    constructor(
        $q,
        $window,
        asNotifier,
        billingConfigurationApiService,
        billingPaymentApiService,
        scriptUtil,
        textResources
    ) {
        this.$q = $q;
        this.$window = $window;
        this.asNotifier = asNotifier;
        this.billingConfigurationApiService = billingConfigurationApiService;
        this.billingPaymentApiService = billingPaymentApiService;
        this.scriptUtil = scriptUtil;
        this.textResources = textResources;

        this.cache = {};
    }

    getPaymentMethods() {
        return this.billingPaymentApiService.getPaymentMethods();
    }

    getCurrentPaymentMethod(doCallApi) {
        if (this.cache.currentPaymentMethod && !doCallApi) {
            return this.$q.resolve(this.cache.currentPaymentMethod);
        }

        var deferred = this.$q.defer();

        this.getPaymentMethods().then(data => {
            if (!data.items) {
                deferred.reject(data);
                return;
            }

            this.cache.currentPaymentMethod = data.items[0];

            deferred.resolve(data.items[0]);
        }, deferred.reject);

        return deferred.promise;
    }

    getClientApi() {
        if (this.cache.clientApi) {
            return this.$q.resolve(this.cache.clientApi);
        }

        var deferred = this.$q.defer();

        this.billingConfigurationApiService.getJsUrls().then(data => {
            this.scriptUtil.loadScripts(data).then(() => {
                if (this.$window.BillingAPI) {
                    this.cache.clientApi = this.$window.BillingAPI;
                    deferred.resolve(this.$window.BillingAPI);
                    return;
                }

                deferred.reject();
            }, deferred.reject);
        }, deferred.reject);

        return deferred.promise;
    }

    getPaymentMethodConfiguration() {
        if (this.cache.paymentMethodConfiguration) {
            return this.$q.resolve(this.cache.paymentMethodConfiguration);
        }

        var deferred = this.$q.defer();

        this.billingConfigurationApiService
            .getPaymentMethodConfiguration()
            .then(data => {
                this.cache.paymentMethodConfiguration = data;
                deferred.resolve(data);
            }, deferred.reject);

        return deferred.promise;
    }

    getPaymentMethodFormConfiguration() {
        var deferred = this.$q.defer();

        this.getPaymentMethodConfiguration().then(data => {
            this.billingConfigurationApiService
                .getPaymentMethodFormConfiguration(data.types[0].formId)
                .then(deferred.resolve, deferred.reject);
        }, deferred.reject);

        return deferred.promise;
    }

    updateCurrentPaymentMethod(paymentMethodId) {
        if (!paymentMethodId) {
            return this.$q.reject('noPaymentMethodId');
        }

        var deferred = this.$q.defer();

        this.billingPaymentApiService
            .updateCurrentPaymentMethod(paymentMethodId)
            .then(
                data => {
                    this.getCurrentPaymentMethod(true);
                    this.asNotifier.success(
                        this.textResources.billingUpdatePaymentMethodSuccess
                    );
                    deferred.resolve(data);
                },
                data => {
                    this.asNotifier.errorAndTryAgain(
                        this.textResources.billingUpdatePaymentMethodFailed
                    );
                    deferred.reject(data);
                }
            );

        return deferred.promise;
    }

    createPayment(paymentDetail) {
        if (!paymentDetail) {
            return this.$q.reject('falsyPaymentDetail');
        }

        let deferred = this.$q.defer();

        this.billingPaymentApiService.createPayment(paymentDetail).then(
            data => {
                this.asNotifier.success(
                    this.textResources.billingMakePaymentMethodSuccess
                );
                deferred.resolve(data);
            },
            data => {
                this.asNotifier.errorAndTryAgain(
                    this.textResources.billingMakePaymentMethodFailed
                );
                deferred.reject(data);
            }
        );

        return deferred.promise;
    }
}

export default billingModule.service(
    'billingPaymentService',
    BillingPaymentService
);



// WEBPACK FOOTER //
// ./modules/billing/services/payment/billingPayment.service.js